/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function TargetParent(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'TargetParent',
      'aria-hidden': true,
      focusable: false,
      width:  15 * scale,
      height: 15 * scale,
      viewBox: '0 0 15 15',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"d":"M13 7a5.5 5.5 0 0 0-5-5V0H7v2a5.5 5.5 0 0 0-5 5H0v1h2a5.5 5.5 0 0 0 5 5v2h1v-2a5.5 5.5 0 0 0 5-5h2V7zm-1 1a4.48 4.48 0 0 1-4 3.95V10H7v1.95A4.48 4.48 0 0 1 3.05 8H5V7H3.05A4.48 4.48 0 0 1 7 3.05V5h1V3.05A4.48 4.48 0 0 1 11.95 7H10v1zM7.5 6.72a.78.78 0 1 0 .78.78.78.78 0 0 0-.78-.78","fill":"currentColor"}))
}
